import * as React from 'react';
import { useSelector } from 'react-redux';

import { Promos as PromosComponent } from '../../../components/NewbuildingPromos/parts/Promos';
import { getNewbuildingPromos, getOffer } from '../../../selectors/newObject';
import { IPromoInfo } from '../../../types/newbuildingPromos';
import { ToggleButton } from '../ToggleButton';
import { trackMorePromosClick } from '../tracking';
import { Promo } from './Promo';

export const Promos = () => {
  const promos = useSelector(getNewbuildingPromos);
  const offer = useSelector(getOffer);

  const onChangeOpen = React.useCallback((opened: boolean) => {
    if (opened) {
      trackMorePromosClick();
    }
  }, []);

  if (!promos || !promos.length) {
    return null;
  }

  return (
    <PromosComponent Button={ToggleButton} onChangeOpen={onChangeOpen}>
      {promos.map((promo: IPromoInfo) => (
        <Promo key={promo.uniquePromoId} promo={promo} offer={offer} />
      ))}
    </PromosComponent>
  );
};

Promos.displayName = 'Promos';
